import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'
import * as componentStore from '../../component-store'

import * as graph from './graph'
import * as nodePanel from './node-panel'
import { Store } from './store'
import * as tools from './tools'

/**
 * Modal used to deploy Quiver resources
 */
@ngCore.Component({
  imports: [
    ds.illustration.emptyState.Component,
    graph.Component,
    tools.Component,
    nodePanel.Component,
  ],
  providers: [Store],
  selector: 'atn-tree-editor-chart',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.OnDestroy {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)
  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.TreeEditor>,
  )
  /** Marks this chart view for zoneless change detection. */
  private readonly _changeDetectorRef = ngCore.inject(ngCore.ChangeDetectorRef)

  /** TODO:  */
  public readonly chartIdSg =
    ngCore.input.required<state.mosaic.treeEditor.models.Chart.Id>({
      alias: 'chartId',
    })

  /** Indicates whether the chart currently has nodes to render */
  public readonly hasDataSg = ngCore.computed(
    (chartId = this.chartIdSg()) =>
      !!chartId &&
      this.store.treeEditorFeature.selectors.getNodes({ chartId }).asSignal()
        .length > 0,
  )

  /** TODO:  */
  private readonly _setChartIdInStore = ngCore.effect(() => {
    const chartId = this.chartIdSg()

    this.store.patchState({ chartId })
  })

  /**
   * Bridges Cytoscape graph clicks into Angular change detection so the chart
   * controls immediately reflect the selected node.
   *
   * Angular 21 enables zoneless change detection by default. Cytoscape owns its
   * selection state and updates it through canvas event handlers, so selecting
   * a node does not notify Angular. The tools template reads that state directly
   * from Cytoscape and otherwise remains stale until an unrelated Angular event
   * or signal schedules change detection, which made the edit button appear
   * after an unpredictable delay.
   *
   * This click bridge is a temporary workaround. A more robust integration
   * should publish Cytoscape `select` and `unselect` events through explicit
   * reactive view state or another framework-neutral callback boundary, then
   * let that notification drive the toolbar independently of DOM click
   * bubbling.
   */
  public graphClickHandler(): void {
    this._changeDetectorRef.markForCheck()
  }

  /**
   * Used to cleanup anything that was created for this org chart (primarily
   * cytoscape)
   */
  public ngOnDestroy(): void {
    const chartId = this.store.validChartIdSg()

    this.store.treeEditorFeature.actions.destroy
      .from('TreeEditor.ngOnDestroy')
      .dispatch({
        chartId,
      })
  }
}
